import React from "react";
// import * as FiIcons from "react-icons/fi";
// import * as HiIcons from "react-icons/hi";
// import * as Hi2Icons from "react-icons/hi2";
// import * as TbIcons from "react-icons/tb";
// import * as LuIcons from "react-icons/lu";
import * as MdIcons from "react-icons/md";
import * as FaIcons from "react-icons/fa";
import * as IOIcons from "react-icons/io5";
import * as RIIcons from "react-icons/ri";

// merge libraries
const allIcons = {
  ...IOIcons,
  ...MdIcons,
  ...FaIcons,
  ...RIIcons,
};

// iconObj = {name:"IoInformationCircle", icon:"IoInformationCircle"}
const IconRenderer = ({ iconObj, size = 24 }) => {
  if (!iconObj) return null;
  const { icon } = iconObj;
  const IconComponent = allIcons[icon];
  if (!IconComponent) return null;
  return <IconComponent size={size} />;
};

export default IconRenderer;